import jwt_decode from 'jwt-decode'
import moment from 'moment'
import { usesFirebaseSession } from '@/utils/session-config'

/** BlytzPay's own logo: the sidebar's fallback, and the BlytzCollect Results print header. */
export const BLYTZPAY_LOGO_URL =
  'https://www.blytzpay.com/hubfs/Logos/Blytzpay-Logo-Pink.png'

export default {
  accessToken(state) {
    return state.accessToken
  },
  firebaseToken(state) {
    return state.firebaseToken
  },
  accessTokenTimeToLive(_, getters) {
    // return function as not to cache
    return () => {
      // Get how long until access token expires
      let ttl = 0
      const claims = getters.accessClaims

      if (claims && claims.exp) {
        ttl = claims.exp - moment().utc().unix()
      }

      return ttl
    }
  },
  refreshTokenTimeToLive(_, getters) {
    // return function as not to cache
    return () => {
      // Get how long until refresh token expires
      let ttl = 0
      const claims = getters.refreshClaims

      if (claims && claims.exp) {
        ttl = claims.exp - moment().utc().unix()
      }

      return ttl
    }
  },
  sessionReady(state) {
    return !usesFirebaseSession() || state.session?.status === 'ready'
  },
  isAuthenticated(state, getters) {
    if (usesFirebaseSession())
      return Boolean(state.session?.principal && state.session?.authorization)

    // If the access token is still
    return 0 < getters.accessTokenTimeToLive()
  },
  isInactive(state, getters) {
    return getters.isAuthenticated && state.isInactive
  },
  accessClaims(state) {
    if (usesFirebaseSession()) return state.session?.authorization || {}
    if (typeof state.accessToken === 'string') {
      return jwt_decode(state.accessToken)
    }

    return {}
  },
  refreshClaims(state) {
    if (typeof state.refreshToken === 'string') {
      return jwt_decode(state.refreshToken)
    }

    return {}
  },
  /**
   * Claims on the Firebase token — the one cfAxios sends to the gateway. Unlike
   * its two siblings this one swallows a decode failure: the token is restored
   * from localStorage and read while the sidebar mounts, before any route guard
   * has looked at it, so a junk value must not take the render down.
   */
  firebaseClaims(state) {
    if (usesFirebaseSession()) return state.session?.claims || {}
    if (typeof state.firebaseToken === 'string') {
      try {
        return jwt_decode(state.firebaseToken)
      } catch {
        return {}
      }
    }

    return {}
  },
  /**
   * The merchant pkid the token is scoped to. auth-service wraps the claim in a
   * list (`util/claims.js`), Django sets it from `organization.pkid`. Null for a
   * super-admin token, which carries no merchant.
   */
  tokenMerchantId(_, getters) {
    const claim = getters.firebaseClaims?.merchantId
    const value = Array.isArray(claim) ? claim[0] : claim

    return value === undefined || value === null || value === ''
      ? null
      : String(value)
  },
  profile(state) {
    return state.profile
  },
  notificationMarks(state) {
    return state.notificationMarks
  },
  isSuper(_, getters) {
    const claims = getters.accessClaims

    return claims.groups?.includes('super')
  },
  profileMerchantLogo(state) {
    let logo = state.profile?.organization.logo
    if (!logo) {
      logo = BLYTZPAY_LOGO_URL
    }

    return logo
  },
  heartbeat(state) {
    return state.heartbeat
  }
}
